<script>
import CMSSinglePage from "@/views/components/cms/CMSSinglePage.vue";

export default {
  name: "Unternehmenspraesentation",
  components: {CMSSinglePage},
}
</script>

<template>
 <CMSSinglePage list-element="UnternehmenspraesentationList"></CMSSinglePage>
</template>

<style scoped>

</style>
